/* eslint-disable */
import React, { useMemo, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useUpdateComponentState } from '../../../hooks';
import HighlightedCardsGrid from '../../components/HighlightedCardsGrid';
import { HCG_ICONS } from './iconMap';
import ExpandableListIllustration from '../../components/ExpandableListIllustration';
import eliIllustration from '../../../../../../assets/student-training/sso/section2-img1.png';
import NumberedStepsCarousel from '../../components/NumberedStepsCarousel';
interface ISection1Props {
  settings: any;
}

const SCAMETER_URL = 'https://cyberdefender.hk/scameter/';
const SCAMETER_TERM_REGEX =
  /(『防騙視伏器』|「防騙視伏器」|『防骗视伏器』|「防骗视伏器」|Scameter)/g;

const renderTextWithScameterLink = (text: string): React.ReactNode => {
  const parts = String(text).split(SCAMETER_TERM_REGEX);
  if (parts.length === 1) return text;
  return parts.map((part, index) =>
    index % 2 === 1 ? (
      <a
        key={index}
        href={SCAMETER_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        {part}
      </a>
    ) : (
      part
    )
  );
};

const Section2: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '3';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const updateComponentState = useUpdateComponentState();
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[2],
    [settings?.paragraphs]
  );

  const onEliComplete = React.useCallback(() => {
    updateComponentState(
      p_course,
      p_topic,
      ID,
      'student-training-sso-section2-1'
    );
  }, [updateComponentState, p_course, p_topic, ID]);

  const downloadRiskItems = useMemo(() => {
    return paragraphsSettings?.items.map((item: any, index: number) => ({
      ...item,
      icon: HCG_ICONS[index](false),
    }));
  }, [paragraphsSettings]);

  const section3List = useMemo(() => {
    return paragraphsSettings?.section3List?.map((item: any) => ({
      ...item,
      text: renderTextWithScameterLink(item.text),
    }));
  }, [paragraphsSettings]);

  return (
    <div className="topic-section-2">
      <HighlightedCardsGrid
        mainTitle={paragraphsSettings?.title}
        subTitle={paragraphsSettings?.subTitle}
        description={paragraphsSettings?.description}
        items={downloadRiskItems}
      />
      <ExpandableListIllustration
        subTitle={paragraphsSettings?.section2Title}
        description={paragraphsSettings?.section2desc}
        illustration={<img src={eliIllustration} alt="" />}
        items={paragraphsSettings?.maliciousFileItems}
        id="student-training-sso-section2-1"
        onComplete={onEliComplete}
      />
      <NumberedStepsCarousel
        type="simple"
        mainTitle={paragraphsSettings?.section3Title}
        description={paragraphsSettings?.section3Desc}
        items={section3List}
        defaultActive={0}
      />
    </div>
  );
};

export default Section2;
